import { ReactComponent as EnergyIcon } from './energy.svg';

export default EnergyIcon;
